module.exports = __webpack_public_path__ + "static/media/gallery_mobile_preview.b010ee38.jpeg";